import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/app";
import { detailsWebhook, getWebHookList } from "../../../store/WebHookSlice";
import ToolBar from "../../../components/ToolBar";
import ListTable from "./components/ListTable";
import FilterForm from "./components/FilterForm";
import ViewWebhook from "./components/ViewWebhook";
import { Result } from "antd";
import { checkPrivileges } from "../../../config/Global";
import { CONSTANT } from "../../../config/Constant";

const WebHook: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [openViewWebhook, setOpenViewWebhook] = useState<any>(false);
  const dispatch: AppDispatch = useDispatch();
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    page_number: 1,
    page_size: 10,
  });
  const getList = useCallback(
    (data?: any) => {
      setLoading(true);
      const payload = {
        ...data,
        page_number: data?.page_number ?? 1,
        page_size: data?.page_size ?? 10,
      };
      setSavePayload(payload);
      dispatch(getWebHookList(payload))
        .then((res: any) => {
          setListData(res.data.data);
          setTotalData(res?.data.totalRecords);
          setLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setLoading(false);
        });
    },
    [dispatch]
  );

  const openViewDrawer = (data: any) => {
    dispatch(detailsWebhook({ id: data._id }))
      .then((res: any) => {
        if (res.data.data) {
          setOpenViewWebhook(res.data.data);
        } else {
          setOpenViewWebhook(CONSTANT.NO_DATA_FOUND);
        }
      })
      .catch(() => {
        setOpenViewWebhook(false);
      });
  };
  useEffect(() => {
    getList();
  }, [getList]);
  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  return (
    <>
      <ToolBar title={"Portability Webhooks"} />
      {checkPrivileges(userRoles, "admin") ? (
        <>
          <FilterForm
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            getList={getList}
          />
          <ListTable
            listData={listData}
            setListData={setListData}
            totalData={totalData}
            tableloading={loading}
            setTableLoading={setLoading}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            getList={getList}
            openViewDrawer={openViewDrawer}
            savePayload={savePayload}
          />
          <ViewWebhook
            openViewWebhook={openViewWebhook}
            setOpenViewWebhook={setOpenViewWebhook}
          />
        </>
      ) : (
        <Result
          status="403"
          title="403"
          subTitle="You don't have enough permission to perform this action."
        />
      )}
    </>
  );
};
export default WebHook;
